import { useMemo, useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { buildNodeMaps, hasSameCheckedKeys } from '../utils/tree-select-checkbox-selection.utils.js';
import { getCanonicalTreeSelectValue, isAncestorsOnlyCheckboxMode } from '../utils/tree-select-selection-model.utils.js';

function useTreeSelectCanonicalFieldValue(_ref) {
  let {
    checkboxSelectionBehavior,
    formContext,
    name,
    options,
    selectionMode
  } = _ref;
  const watchedValue = useWatch({
    control: formContext.control,
    name
  });
  const shouldSyncCanonicalValue = isAncestorsOnlyCheckboxMode(checkboxSelectionBehavior, selectionMode);
  const nodeMaps = useMemo(() => shouldSyncCanonicalValue ? buildNodeMaps(options) : undefined, [options, shouldSyncCanonicalValue]);
  const canonicalValue = useMemo(() => {
    return getCanonicalTreeSelectValue(watchedValue, nodeMaps, shouldSyncCanonicalValue);
  }, [nodeMaps, shouldSyncCanonicalValue, watchedValue]);
  useEffect(() => {
    if (!shouldSyncCanonicalValue || !nodeMaps || hasSameCheckedKeys(watchedValue, canonicalValue)) {
      return;
    }
    formContext.setValue(name, canonicalValue, {
      shouldDirty: false,
      shouldTouch: false,
      shouldValidate: false
    });
  }, [canonicalValue, formContext, name, nodeMaps, shouldSyncCanonicalValue, watchedValue]);
}

export { useTreeSelectCanonicalFieldValue };
